import React, { useState, useEffect, useRef } from 'react';
import BasicCard from '../../../components/basics/cards/BasicCard'
import $ from 'jquery'
import '../../basicreport/basicReport.css'
import { TokenService } from '../../../services/TokenService';
import { CommonAPIService } from "../../../services/apis/CommonAPIService";
import { MitigationAPIService } from "../../../services/apis/MitigationAPIService";
import '../../../components/data-table/data-table.css'
import { ErrorService } from '../../../services/ErrorService';

function MitigationList({ filterArray, pageConfig }) {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { apiName, controllerName, pageSettings } = pageConfig
    const [succeessMessage, setSucceessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const tableRef = useRef()
    const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const years = [2, 3, 4, 5, 6, 7, 8, 9, 10];

    $.DataTable = require('datatables.net')

    const user = TokenService.getUser();

    const tableConfig = {
        columns: ['Edit', 'ScenarioName', '1wk', '1mth', '2mth', '3mth'
            , '4mth', '5mth', '6mth', '7mth', '8mth', '9mth', '10mth', '11mth', '12mth', '2yrs', '3yrs', '4yrs', '5yrs', '6yrs', '7yrs'
            , '8yrs', '9yrs', '10yrs', 'Comment']
    }

    useEffect(() => {
        //var dummyData = [
        //    {
        //        identifier: "3fa85f64-5717-4562-b3fc-2c963f66afa6", scenarioId: "1", scenarioCode: "Code A", scenarioName: "A", b1wk: 1, b1mth: 2, b2mth: 3, b3mth: 3,
        //        b4mth: 4, b5mth: 5, b6mth: 6, b7mth: 7, b8mth: 8, b9mth: 9, b10mth: 10, b11mth: 11, b12mth: 12, b2yrs: 2, b3yrs: 3, b4yrs: 4, b5yrs: 5, b6yrs: 6, b7yrs: 7, b8yrs: 8, b9yrs: 9, b10yrs: 10, comments: "This is test",
        //        filter: { applicationUserId: 1, currencyId: 1, dataVersionId: 1, nodeId: 1, periodId: 1}
        //            },
        //    {
        //        identifier: "3fa85f64-5717-4562-b3fc-2c963f66afa5", scenarioId: "2", scenarioCode: "Code B", scenarioName: "B", b1wk: 1, b1mth: 2, b2mth: 3, b3mth: 3,
        //        b4mth: 4, b5mth: 5, b6mth: 6, b7mth: 7, b8mth: 8, b9mth: 9, b10mth: 10, b11mth: 11, b12mth: 12, b2yrs: 2, b3yrs: 3, b4yrs: 4, b5yrs: 5, b6yrs: 6, b7yrs: 7, b8yrs: 8, b9yrs: 9, b10yrs: 10, comments: "This is test11",
        //        filter: { applicationUserId: 1, currencyId: 1, dataVersionId: 1, nodeId: 1, periodId: 1 }
        //            }
        //];
        //setData(dummyData);
        setIsLoading(false);
        if (Array.isArray(filterArray)) {
            const filterArrayString = encodeURIComponent(JSON.stringify(filterArray));
            // fetch data from API
            setIsLoading(true);
            CommonAPIService.callApiUsingUrl(`${apiName}${controllerName}/Data?filterArray=${filterArrayString}`)
                .then(response => {
                    if (response.error) {
                        setErrorMessage(ErrorService.getErrorMessage(data.error.status))
                    }
                    setIsLoading(false);
                    setData(response);
                })
        }
    }, [apiName, controllerName, filterArray]);

    const handleEdit = (index) => {

        document.getElementById("edit_" + index).style.display = "none";
        document.getElementById("save_" + index).style.display = "block";

        showHideInputBox(index);
    }

    const handleSave = (index) => {

        var mitigation = data[index];

        MitigationAPIService.updateMitigation(mitigation).then(
            response => {
                setSucceessMessage("");
                setErrorMessage("");
                if (response.error) 
                    setErrorMessage(ErrorService.getErrorMessage(data.error.status))
                else 
                    setSucceessMessage("Mitigation have been successfully saved.");
            }
        );

        document.getElementById("save_" + index).style.display = "none";
        document.getElementById("edit_" + index).style.display = "block";
        showHideInputBox(index);
    }

    const showHideInputBox = (index) => {
        if (document.getElementById("l_scenarioName_" + index).style.display === "none") {
            //show the labels
            showHideLabels(index, false);
            //hide the input boxes
            showHideInputBoxes(index, true);
        }
        else {

            //show the input boxes
            showHideInputBoxes(index, false);
            //hide the labels
            showHideLabels(index, true);
        }

    }

    const showHideLabels = (index, isHide) => {
        if (isHide) {
            document.getElementById("l_scenarioName_" + index).style.display = "none";
            document.getElementById("l_b1wk_" + index).style.display = "none";
            document.getElementById("l_comments_" + index).style.display = "none";

            months.map((i) => {
                document.getElementById("l_b" + i + "mth_" + index).style.display = "none";
            })

            years.map((i) => {
                document.getElementById("l_b" + i + "yrs_" + index).style.display = "none";
            })
        }
        else {
            document.getElementById("l_scenarioName_" + index).style.display = "block";
            document.getElementById("l_b1wk_" + index).style.display = "block";
            document.getElementById("l_comments_" + index).style.display = "block";

            months.map((i) => {
                document.getElementById("l_b" + i + "mth_" + index).style.display = "block";
            })

            years.map((i) => {
                document.getElementById("l_b" + i + "yrs_" + index).style.display = "block";
            })
        }

    }

    const showHideInputBoxes = (index, isHide) => {
        if (isHide) {
            document.getElementById("t_scenarioName_" + index).style.display = "none";
            document.getElementById("t_b1wk_" + index).style.display = "none";
            document.getElementById("t_comments_" + index).style.display = "none";


            months.map((i) => {
                document.getElementById("t_b" + i + "mth_" + index).style.display = "none";
            })

            years.map((i) => {
                document.getElementById("t_b" + i + "yrs_" + index).style.display = "none";
            })
        }
        else {
            document.getElementById("t_scenarioName_" + index).style.display = "block";
            document.getElementById("t_b1wk_" + index).style.display = "block";
            document.getElementById("t_comments_" + index).style.display = "block";

            months.map((i) => {
                document.getElementById("t_b" + i + "mth_" + index).style.display = "block";
            })

            years.map((i) => {
                document.getElementById("t_b" + i + "yrs_" + index).style.display = "block";
            })

        }

    }

    const handleChange = (e) => {
        setSucceessMessage("");
        setErrorMessage("");
        const nameArr = e.target.name.split("_");
        var name = nameArr[0];
        var arrIndex = nameArr[1];
        const value = e.target.value;

        const mitigations = data.map((mitigation, index) => {
            if (index != arrIndex) {
                // No change
                return mitigation;
            } else {
                // Return a new circle 50px below
                return {
                    ...mitigation,
                    [name]: value,
                };
            }
        });

        setData(mitigations);        
    }

    useEffect(() => {
        const table = $(tableRef.current).DataTable({
            dom: '<"data-table-wrapper"t>',
            select: true,
            lengthChange: false,
            destroy: true
        })
        return () => table.destroy()
    }, [])


    return (
        <BasicCard cardConfig={{ cardTitle: pageSettings ? pageSettings.name : '...', cardHeadingElement: 'h5' }}>
            {succeessMessage ?
                <p style={{ color: 'green' }}>{succeessMessage}</p> : ""
            }
            {errorMessage ?
                <p style={{ color: 'red' }}>{errorMessage}</p> : ""
            }
            {!isLoading ?
                <table className='react-data-table' ref={tableRef}>
                    <thead>
                        <tr>
                            {
                                tableConfig.columns.map((column, index) => <th key={index}>{column}</th>)
                            }
                        </tr>
                    </thead>
                    {data?.length > 0 && (
                        <tbody>
                            {data.map((tableRow, index) => {
                                return (
                                    <tr key={index}>
                                        <td>
                                            <div className='data-table-input-cell'>
                                                <p className='data-table-text' id={'edit_' + index} style={{ cursor: 'pointer' }} onClick={() => handleEdit(index)}>Edit</p>
                                                <p className='data-table-text' style={{ display: 'none', cursor: 'pointer' }} id={'save_' + index} onClick={() => handleSave(index)}>Save</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='data-table-input-cell'>
                                                <p className='data-table-text' id={'l_scenarioName_' + index}>{tableRow['scenarioName']}</p>
                                                <p className='data-table-text' id={'t_scenarioName_' + index} style={{ display: 'none' }}>
                                                    <input id={'scenarioName_' + index} name={'scenarioName_' + index} onChange={handleChange} type="text" className='form-input' value={tableRow['scenarioName']} />
                                                </p>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='data-table-input-cell'>
                                                <p className='data-table-text' id={'l_b1wk_' + index}>{tableRow['b1wk']}</p>
                                                <p className='data-table-text' id={'t_b1wk_' + index} style={{ display: 'none', width: 'fit-content' }}><input id={'b1wk_' + index} name={'b1wk_' + index} type="number" size="10" className='form-input' onChange={handleChange} value={tableRow['b1wk']}></input></p>
                                            </div>
                                        </td>
                                        {months.map((i) => {
                                            return (
                                                <td key={i}>
                                                    <div className='data-table-input-cell'>
                                                        <p className='data-table-text' id={'l_b' + i + 'mth_' + index}>{tableRow['b' + i + 'mth']}</p>
                                                        <p className='data-table-text' id={'t_b' + i + 'mth_' + index} style={{ display: 'none', width: 'fit-content' }}><input id={'b' + i + 'mth_' + index} name={'b' + i + 'mth_' + index} type="number" size="10" onChange={handleChange} className='form-input' value={tableRow['b' + i + 'mth']}></input></p>
                                                    </div>
                                                </td>
                                            )
                                        }
                                        )
                                        }

                                        {years.map((i) => {
                                            return (
                                                <td key={i}>
                                                    <div className='data-table-input-cell'>
                                                        <p className='data-table-text' id={'l_b' + i + 'yrs_' + index}>{tableRow['b' + i + 'yrs']}</p>
                                                        <p className='data-table-text' id={'t_b' + i + 'yrs_' + index} style={{ display: 'none', width: 'fit-content' }}><input id={'b' + i + 'yrs_' + index} name={'b' + i + 'yrs_' + index} type="number" size="10" onChange={handleChange} className='form-input' value={tableRow['b' + i + 'yrs']}></input></p>
                                                    </div>
                                                </td>
                                            )
                                        }
                                        )
                                        }

                                        <td>
                                            <div className='data-table-input-cell'>
                                                <p className='data-table-text' id={'l_comments_' + index}>{tableRow['comment']}</p>
                                                <p className='data-table-text' id={'t_comments_' + index} style={{ display: 'none' }}><input id={'comment_' + index} name={'comment_' + index} type="text" size="15" className='form-input' onChange={handleChange} value={tableRow['comment']}></input></p>
                                            </div>
                                        </td>

                                    </tr>
                                )
                            })}
                        </tbody>
                    )}
                </table>
                : <p> Loading...</p>
            }
        </BasicCard>
    );
}

export default MitigationList;
